/**
 * Customized to add new styles for controls quantity input component
 */

import { SxProps } from '@mui/material';

export const quantityControlsSX = {
	controls: (disabled: boolean, isMinimumValue?: boolean): SxProps => ({
		alignItems: 'center',
		alignSelf: 'stretch',
		...(isMinimumValue ? { color: 'grey.200' } : { color: 'primary.main' }),
		...(isMinimumValue && { cursor: 'not-allowed' }),
		...(disabled && { backgroundColor: 'grey.50' }),

		':hover': {
			backgroundColor: 'white',
		},

		'&.MuiButtonBase-root': {
			padding: 1,

			':hover': {
				...(isMinimumValue ? { color: 'grey.200' } : { color: 'primary.main' }),
				backgroundColor: 'white',
			},
		},
		'&:first-of-type': {
			ml: -1.8,
			borderRight: '1px solid',
			borderRightColor: 'grey.100',
			borderTopRightRadius: 0,
			borderBottomRightRadius: 0,
		},
		'&:last-of-type': {
			mr: -1.8,
			borderLeft: '1px solid',
			borderLeftColor: 'grey.100',
			borderTopLeftRadius: 0,
			borderBottomLeftRadius: 0,
		},
		' > svg': {
			fontSize: '1rem',
		},
	}),
};
